import makeInitialState from 'client/makeInitialState';

export default async function reset({ state }) {
  state.set(['listings'], makeInitialState().listings);
  state.set(['listingsMapView'], makeInitialState().listingsMapView);
  state.commit();
}
